import Vue from "vue";
import Vuex from "vuex";
import * as fb from "@/firebase";
import router from "@/router/index";
import { nameCheck, NUTRIENT_KEYS } from "@/main.js";
import i18n from "@/i18n/i18n"

Vue.use(Vuex);

const { v4: uuidv4 } = require("uuid");
/** The input of the whole nutrients production should be considered separately, i.e., it corresponds directly to the fertilizer production. */
const CATEGORY_ID_DIRECT_INPUT = 'animal_07'; 

export default new Vuex.Store({
  state: {
    nutrient_values: [],
    categories: [],
    regions: [],
    projects: [],
    project: null,
    user: null,
    isAuthenticated: false,
    country: "CH",
    message: "",
    showModal: false,
    pageTitle: null,
    locale: null
  },

  mutations: {
    setMessage(state,val) {
      state.message = val;
    },

    toggleModal(state) {
      state.showModal = !state.showModal;
    },

    setAuthenticated(state, val) {
      if (state.isAuthenticated != val) {
        state.isAuthenticated = val;
      }
      let targetRoute = val ? "/projects/list" : "/";

      if (router.currentRoute.path != targetRoute) {
        router.push(targetRoute);
      }
    },

    setUserProfile(state, val) {
      state.user = val;
      
    },

    setLocale(state, val) {
      state.locale = val;
    },

    newProject(state, val) {
      state.project = {
        project_id: uuidv4(),
        user_id: fb.auth.currentUser.uid,
        created_on: Date.now(),
        name: val.projectName,
        regions: val.regions.map((r) => r.id),
        plant_output: [],
        animal_output: [],
        nutrient_sources: [],
        acreage: 0,
        demand_fulfillments: [],
        demand_fulfillment: null,
        // TODO: The following default values should come from a 'config' database object
        deposition: 25,
        lossesStorage: 15,
        lossesOutput: 10,
        losses_pct: 0
      };
      fb.projectsCollection
        .doc(state.project.project_id)
        .set(state.project)
        .then(() => {
          console.log(
            "Project " +
              state.project.project_id +
              " of the user " +
              fb.auth.currentUser.uid +
              " successfully created."
          );
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    setProject(state, val) {
      if (val) {
        console.log("Setting project " + val.project_id);
      } else {
        state.project_tab = 0;
      }
       
      state.project = val;
    },

    setProjects(state, val) {
      state.projects = val;
    },

    setProjectTab (state, val) {
      state.project_tab = val;
    },

    setNutrientValues(state, val) {
      state.nutrient_values = val;
    },

    setRegions(state, val) {
      state.regions = val;
    },

    setCategories(state, val) {
      state.categories = val;
    },

    setUnits(state, val) {
      state.units = val;
    },

    setCountry(state, val) {
      state.country = val;
    },

    setPageTitle (state, val) {
      state.pageTitle = val;
    },

    setDemandFulfillment(state, index) {
      state.project.demand_fulfillment = state.project.demand_fulfillments[index];
    },

    updateDemandFulfillments(state) {
      let acreage_sum = state.project.plant_output
        .filter((output) => 
          (output.acreage_input && output.included == undefined) || (output.acreage_input && output.included == true)
        )
        .reduce((val, output) => val + parseInt(output.acreage_input), 0);
      for (var key in state.project.demand_fulfillments) {
        let demandFulfillment = state.project.demand_fulfillments[key];
        
        for (var source_idx in demandFulfillment.nutrient_sources) {
          let source = demandFulfillment.nutrient_sources[source_idx];
          if (source.amount !== 0) {
            source.N_t = source.amount * source.N * 0.001;
            source.P_t = source.amount * source.P * 0.001;
            source.K_t = source.amount * source.K * 0.001;
            if (acreage_sum > 0) {
              source.N_kg_ha = source.N_t / acreage_sum * 1000;
              source.P_kg_ha = source.P_t / acreage_sum * 1000;
              source.K_kg_ha = source.K_t / acreage_sum * 1000;
            }
          }
        }
      }
    },

    updateDemandValues(state, {index,val}) {
      if (val || val === '' || val === 0) {
        let source = state.project.demand_fulfillment.nutrient_sources[index];
        let parsedVal = parseFloat(val);
        if (Number.isInteger(parsedVal)) {
          source.amount = parsedVal;
          source.amount_input = parsedVal;
        } else {
          source.amount = 0;
          source.amount_input = 0;
        } 

        if (!source.N) {
          source.N = 0;
        }
        if (!source.P) {
          source.P = 0;
        }
        if(!source.K) {
          source.K = 0;
        }

        let acreage_sum = state.project.plant_output
        .filter((output) => 
          (output.acreage_input && output.included == undefined) || (output.acreage_input && output.included == true)
        )
        .reduce((val, output) => val + parseInt(output.acreage_input), 0);

        source.N_t = parseFloat(source.amount * source.N * 0.001);
        source.P_t = parseFloat(source.amount * source.P * 0.001);
        source.K_t = parseFloat(source.amount * source.K * 0.001);
   
        if (acreage_sum) {
          source.N_kg_ha = parseFloat(source.N_t /acreage_sum * 1000);
          source.P_kg_ha = parseFloat(source.P_t /acreage_sum * 1000);
          source.K_kg_ha = parseFloat(source.K_t / acreage_sum * 1000);
        }

        this.commit("updateDemandScenario");
      }
    },

    updateNutrientValues(state) {
      for (let index = 0; index < state.project.demand_fulfillment.nutrient_sources.length; index++) {
        let source = state.project.demand_fulfillment.nutrient_sources[index];
      
        if (!source.N) {
          source.N = 0;
        }
        if (!source.P) {
          source.P = 0;
        }
        if(!source.K) {
          source.K = 0;
        }

        if (!source.amount) {
          source.amount = 0;
        }

        let acreage_sum = state.project.plant_output
        .filter((output) => 
          (output.acreage_input && output.included == undefined) || (output.acreage_input && output.included == true)
        )
        .reduce((val, output) => val + parseInt(output.acreage_input), 0);

        source.N_t = parseFloat(source.amount * source.N * 0.001);
        source.P_t = parseFloat(source.amount * source.P * 0.001);
        source.K_t = parseFloat(source.amount * source.K * 0.001);
   
        if (acreage_sum) {
          source.N_kg_ha = parseFloat(source.N_t /acreage_sum * 1000);
          source.P_kg_ha = parseFloat(source.P_t /acreage_sum * 1000);
          source.K_kg_ha = parseFloat(source.K_t / acreage_sum * 1000);
        }

        this.commit("updateDemandScenario");
      }
    },

    updateDemandScenario(state) {
      if(state.project && state.project.demand_fulfillment) {
        state.project.demand_fulfillment.scenario.N.total_extern_fertilizer_t = state.project.demand_fulfillment.nutrient_sources.filter(
          (source) => (source.amount !== 0)
        )
        .reduce((val, source) => val + source.N_t, 0);

        state.project.demand_fulfillment.scenario.P.total_extern_fertilizer_t = state.project.demand_fulfillment.nutrient_sources.filter(
          (source) => (source.amount !== 0)
        )
        .reduce((val, source) => val + source.P_t, 0);

        state.project.demand_fulfillment.scenario.K.total_extern_fertilizer_t = state.project.demand_fulfillment.nutrient_sources.filter(
          (source) => (source.amount !== 0)
        )
        .reduce((val, source) => val + source.K_t, 0);

        let acreage_sum = state.project.plant_output
        .filter((output) => 
          (output.acreage_input && output.included == undefined) || (output.acreage_input && output.included == true)
        )
        .reduce((val, output) => val + parseInt(output.acreage_input), 0);

        if (acreage_sum) {
          state.project.demand_fulfillment.scenario.N.total_extern_fertilizer_kg_ha = state.project.demand_fulfillment.scenario.N.total_extern_fertilizer_t/acreage_sum * 1000;
          state.project.demand_fulfillment.scenario.P.total_extern_fertilizer_kg_ha = state.project.demand_fulfillment.scenario.P.total_extern_fertilizer_t/acreage_sum * 1000;
          state.project.demand_fulfillment.scenario.K.total_extern_fertilizer_kg_ha = state.project.demand_fulfillment.scenario.K.total_extern_fertilizer_t/acreage_sum * 1000;
        }

        state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview = state.project.animal_output
          .filter((output) => output.amount_input && output.category_id !== CATEGORY_ID_DIRECT_INPUT)
          .reduce(
            (val, output) => val + parseInt(output.amount_input) * output['N'],
            0
          );
        state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview = state.project.animal_output
          .filter((output) => output.amount_input && output.category_id !== CATEGORY_ID_DIRECT_INPUT)
          .reduce(
            (val, output) => val + parseInt(output.amount_input) * output['P'],
            0
          );

        state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview = state.project.animal_output
          .filter((output) => output.amount_input && output.category_id !== CATEGORY_ID_DIRECT_INPUT)
          .reduce(
            (val, output) => val + parseInt(output.amount_input) * output['K'],
            0
          );

        for (let j in state.project.animal_output) {
          let animalOutput = state.project.animal_output[j];
          if (animalOutput.category_id === CATEGORY_ID_DIRECT_INPUT) {
            state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview += animalOutput.amount_input * 1000;
            state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview += animalOutput.amount_input * 1000;
            state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview += animalOutput.amount_input * 1000;
          }
        }

        state.project.demand_fulfillment.scenario.N.nutrient_demand = state.project.plant_output
        .filter((output) => output.acreage_input)
        .reduce(
          (val, output) => val + parseInt(output.acreage_input) * output['N'],
          0
        );

        state.project.demand_fulfillment.scenario.P.nutrient_demand = state.project.plant_output
        .filter((output) => output.acreage_input)
        .reduce(
          (val, output) => val + parseInt(output.acreage_input) * output['P'],
          0
        );

        state.project.demand_fulfillment.scenario.K.nutrient_demand = state.project.plant_output
        .filter((output) => output.acreage_input)
        .reduce(
          (val, output) => val + parseInt(output.acreage_input) * output['K'],
          0
        );

        if (acreage_sum) {
          state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview_per_ha = state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview/ acreage_sum;
          state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview_per_ha = state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview/ acreage_sum;
          state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview_per_ha = state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview/ acreage_sum;

          state.project.demand_fulfillment.scenario.N.nutrient_demand_per_ha = state.project.demand_fulfillment.scenario.N.nutrient_demand/ acreage_sum;
          state.project.demand_fulfillment.scenario.P.nutrient_demand_per_ha = state.project.demand_fulfillment.scenario.P.nutrient_demand/ acreage_sum;
          state.project.demand_fulfillment.scenario.K.nutrient_demand_per_ha = state.project.demand_fulfillment.scenario.K.nutrient_demand/ acreage_sum;

          //state.project.demand_fulfillment.scenario.N.surplus_per_ha = state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview_per_ha - state.project.demand_fulfillment.scenario.N.nutrient_demand_per_ha;
          state.project.demand_fulfillment.scenario.P.surplus_per_ha = state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview_per_ha - state.project.demand_fulfillment.scenario.P.nutrient_demand_per_ha;
          state.project.demand_fulfillment.scenario.K.surplus_per_ha = state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview_per_ha - state.project.demand_fulfillment.scenario.K.nutrient_demand_per_ha;        
        }

        state.project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_pct = 
            (((state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview * 0.001) + state.project.demand_fulfillment.scenario.N.total_extern_fertilizer_t)/(state.project.demand_fulfillment.scenario.N.nutrient_demand * 0.001)) * 100;  

            state.project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_pct = 
            (((state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview * 0.001) + state.project.demand_fulfillment.scenario.P.total_extern_fertilizer_t)/(state.project.demand_fulfillment.scenario.P.nutrient_demand * 0.001)) * 100; 

        state.project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_pct = 
            (((state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview * 0.001) + state.project.demand_fulfillment.scenario.K.total_extern_fertilizer_t)/(state.project.demand_fulfillment.scenario.K.nutrient_demand * 0.001)) * 100; 

        state.project.demand_fulfillment.scenario.N.bnf = state.project.plant_output
            .filter((output) => output.acreage_input && output.bnf)
            .reduce(
              (val, output) =>
                val + parseInt(output.acreage_input) * output.bnf,
              0
            );
        
        if (acreage_sum) {
          state.project.demand_fulfillment.scenario.N.deposition = (state.project.deposition * acreage_sum);
        }

        state.project.demand_fulfillment.scenario.N.losses = 
        (state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview * 0.001) *
        state.project.losses_pct /100;

        state.project.demand_fulfillment.scenario.N.surplus = state.project.demand_fulfillment.scenario.N.demand_fulfillment_overview * 0.001
         - state.project.demand_fulfillment.scenario.N.nutrient_demand * 0.001 
         + state.project.demand_fulfillment.scenario.N.bnf * 0.001
         + state.project.demand_fulfillment.scenario.N.deposition * 0.001
         - state.project.demand_fulfillment.scenario.N.losses;
        
        if (acreage_sum) {
          state.project.demand_fulfillment.scenario.N.surplus_per_ha = state.project.demand_fulfillment.scenario.N.surplus/acreage_sum * 1000; 
        }

        state.project.demand_fulfillment.scenario.N.surplus_pct = (state.project.demand_fulfillment.scenario.N.surplus / state.project.demand_fulfillment.scenario.N.nutrient_demand) * 100;
       
        
        state.project.demand_fulfillment.scenario.P.surplus = state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview * 0.001 - state.project.demand_fulfillment.scenario.P.nutrient_demand * 0.001;
        state.project.demand_fulfillment.scenario.K.surplus = state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview * 0.001 - state.project.demand_fulfillment.scenario.K.nutrient_demand * 0.001;

         
        state.project.demand_fulfillment.scenario.P.surplus_pct = (state.project.demand_fulfillment.scenario.P.demand_fulfillment_overview / state.project.demand_fulfillment.scenario.P.nutrient_demand) * 100;
        state.project.demand_fulfillment.scenario.K.surplus_pct = (state.project.demand_fulfillment.scenario.K.demand_fulfillment_overview / state.project.demand_fulfillment.scenario.K.nutrient_demand) * 100;

        state.project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_t = state.project.demand_fulfillment.scenario.N.total_extern_fertilizer_t + state.project.demand_fulfillment.scenario.N.surplus;
        state.project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_t = state.project.demand_fulfillment.scenario.P.total_extern_fertilizer_t + state.project.demand_fulfillment.scenario.P.surplus;
        state.project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_t = state.project.demand_fulfillment.scenario.K.total_extern_fertilizer_t + state.project.demand_fulfillment.scenario.K.surplus;

        
        state.project.demand_fulfillment.scenario.N.extern_fertilizer_surplus_kg_ha = state.project.demand_fulfillment.scenario.N.total_extern_fertilizer_kg_ha + state.project.demand_fulfillment.scenario.N.surplus_per_ha;
        state.project.demand_fulfillment.scenario.P.extern_fertilizer_surplus_kg_ha = state.project.demand_fulfillment.scenario.P.total_extern_fertilizer_kg_ha + state.project.demand_fulfillment.scenario.P.surplus_per_ha;
        state.project.demand_fulfillment.scenario.K.extern_fertilizer_surplus_kg_ha = state.project.demand_fulfillment.scenario.K.total_extern_fertilizer_kg_ha + state.project.demand_fulfillment.scenario.K.surplus_per_ha;
      }
    },

    updateDemandValueN(state, {index,val}) {
      if (val) {
        let source = state.project.demand_fulfillment.nutrient_sources[index];
        source.N = parseFloat(val);
  
        if (!source.amount) {
          source.N_t = 0;
        } else {
          source.N_t = parseFloat(source.amount * source.N * 0.001);
        }

        this.commit("updateNutrientValues");
        this.commit("updateDemandScenario");
      }
    },

    updateAnimalOutputValueN(state, {index,val}) {
      if (val) {
        let source = state.project.animal_output[index];
        source.N = val;
      }
    },

    updateDemandValueP(state, {index,val}) {
      if (val) {
        let source = state.project.demand_fulfillment.nutrient_sources[index];
        source.P = parseFloat(val);
  
        if (!source.amount) {
          source.P_t = 0;
        } else {
          source.P_t = parseFloat(source.amount * source.P * 0.001);
        }

        this.commit("updateNutrientValues");
        this.commit("updateDemandScenario");
      }
    },

    updateAnimalOutputValueP(state, {index,val}) {
      if (val) {
        let source = state.project.animal_output[index];
        source.P = val;
      }
    },

    updateDemandValueK(state, {index,val}) {
      if (val) {
        let source = state.project.demand_fulfillment.nutrient_sources[index];
        source.K = parseFloat(val);
  
        if (!source.amount) {
          source.K_t = 0;
        } else {
          source.K_t = parseFloat(source.amount * source.K * 0.001);
        }

        this.commit("updateNutrientValues");
        this.commit("updateDemandScenario");
      }
    },

    updateAnimalOutputValueK(state, {index,val}) {
      if (val) {
        let source = state.project.animal_output[index];
        source.K = val;
      }
    },

    updateAnimalAmountValue(state, {index,val}) {
      let value = 0;
      if (val) { 
        value = val;
      } 
      let animal_output = state.project.animal_output[index];
      animal_output.amount_input = value;
      if (animal_output.category_id === CATEGORY_ID_DIRECT_INPUT) {
        if(animal_output['name_'+i18n.locale] === i18n.t('animalProduction.items.item1')) {
          animal_output.K = value * 1000;
          animal_output.P = 0;
          animal_output.N = 0;
        } else if (animal_output['name_'+i18n.locale] === i18n.t('animalProduction.items.item2')) {
          animal_output.P = value * 1000;
          animal_output.K = 0;
          animal_output.N = 0; 
        } else if(animal_output['name_'+i18n.locale] === i18n.t('animalProduction.items.item3')){
          animal_output.N = value * 1000;
          animal_output.K = 0;
          animal_output.P = 0;
        }
      }
      
    },

    addOutput(state, val) {
      state.project.output.push(val);
      val.project_id = state.project.id;
    },

    addNewDemandFulfillment(state,val) {
      var createFulfillmentName = name => 
        nameCheck(
          name, 
          state.project.demand_fulfillments.map(out => out.name)
        ); 
      var demand = Object.assign({},val);
      demand.project_id = state.project.project_id;
      demand.id = state.project.demand_fulfillments.length+1;
      demand.created_on = Date.now();
      // A new demand fulfillment has been created, i.e., the name has been already defined by an user
      if (val.name && (val.id === null)) {
        let nutrientSources = [];
        state.project.nutrient_sources.forEach((source) => {
          nutrientSources.push(Object.assign({ amount: null, amount_input: null, N:0, P:0, K:0 }, source));
        });
        demand.nutrient_sources = nutrientSources;
      }
      // In that case, a fulfillment has been duplicated, i.e., the rest of the values should be copied
      if (val.id) {
        demand.name = createFulfillmentName(val.name);
      }
      // Initialize values for the external fertilizer nutrients
      demand.scenario = {
        N: {
          demand_fulfillment_overview: 0,
          nutrient_demand: 0,
          demand_fulfillment_overview_per_ha: 0,
          nutrient_demand_per_ha: 0,
          surplus_per_ha: 0,
          surplus_pct: 0,
          surplus: 0,
          total_extern_fertilizer_t: 0,
          total_extern_fertilizer_kg_ha: 0,
          extern_fertilizer_surplus_pct: 0,
          extern_fertilizer_surplus_t: 0,
          extern_fertilizer_surplus_kg_ha: 0
        },
        P: {
          demand_fulfillment_overview: 0,
          nutrient_demand: 0,
          demand_fulfillment_overview_per_ha: 0,
          nutrient_demand_per_ha: 0,
          surplus_per_ha: 0,
          surplus_pct: 0,
          surplus: 0,
          total_extern_fertilizer_t: 0,
          total_extern_fertilizer_kg_ha: 0,
          extern_fertilizer_surplus_pct: 0,
          extern_fertilizer_surplus_t: 0,
          extern_fertilizer_surplus_kg_ha: 0
        },
        K: {
          demand_fulfillment_overview: 0,
          nutrient_demand: 0,
          demand_fulfillment_overview_per_ha: 0,
          nutrient_demand_per_ha: 0,
          surplus_per_ha: 0,
          surplus_pct: 0,
          surplus: 0,
          total_extern_fertilizer_t: 0,
          total_extern_fertilizer_kg_ha: 0,
          extern_fertilizer_surplus_pct: 0,
          extern_fertilizer_surplus_t: 0,
          extern_fertilizer_surplus_kg_ha: 0
        },
      };
      state.project.demand_fulfillment = demand;
      state.project.demand_fulfillments.push(demand);

      this.dispatch('saveProject');
      
      router.push({
        path: `/projects/${state.project.project_id}` + `/fulfillment/${demand.id}`
      });
    },

    addNewNutrientSource(state, val) {
      var createNutrientSourceName = (name) =>
        nameCheck(
          name,
          state.project.nutrient_sources.map((out) => out['name_'+i18n.locale])
        );
      var newItem = Object.assign({}, val);
      delete newItem.id;
      if (!val['name_'+i18n.locale]) {
        newItem.name_de = "";
        newItem.name_en = "";
        
        newItem.N = 0;
        newItem.P = 0;
        newItem.K = 0;
        
        newItem.N_t = 0;
        newItem.P_t = 0;
        newItem.K_t = 0;
        
        newItem.N_kg_ha = 0;
        newItem.P_kg_ha = 0;
        newItem.K_kg_ha = 0;

        newItem.amount = null;
        newItem.amount_input = null;

      } else {
        newItem.name_de = createNutrientSourceName(val.name_de);
        newItem.name_en = createNutrientSourceName(val.name_en);
      }
      newItem.added_uid = uuidv4();
      newItem.category_id = val.category_id;
      newItem.unit_input = val.unit_input;
      state.project.demand_fulfillment.nutrient_sources.push(newItem);
    },

    addNewPlantOutput(state, val) {
      var createOutputName = (name) =>
        nameCheck(
          name,
          state.project.plant_output.map((out) => out['name_'+i18n.locale])
        );
      var newItem = Object.assign({}, val);
      delete newItem.id;
      if (!val['name_'+i18n.locale]) {
        newItem.name_de = "";
        newItem.name_en = "";
        newItem.N = 0;
        newItem.P = 0;
        newItem.K = 0;
        newItem.acreage = 0;
        newItem.yield = 0;
        newItem.yield_actual = 0;
      } else {
        newItem.name_de = createOutputName(val.name_de);
        newItem.name_en = createOutputName(val.name_en);
      }
      newItem.added_uid = uuidv4();
      state.project.plant_output.push(newItem);
    },

    addNewAnimalOutput(state, item) {
      var createAnimalOutputName = (name) =>
        nameCheck(
          name,
          state.project.animal_output.map((out) => out['name_'+i18n.locale])
        );
      var newItem = Object.assign({}, item);
      delete newItem.id;
      if (!item['name_'+i18n.locale]) {
        newItem.name_de = "";
        newItem.name_en = "";
        newItem.N = 0;
        newItem.P = 0;
        newItem.K = 0;
        newItem.amount_input = null;
        newItem.yield = 0;
      } else {
        newItem.name_de = createAnimalOutputName(item.name_de);
        newItem.name_en = createAnimalOutputName(item.name_en);
      }
      newItem.added_uid = uuidv4();
      state.project.animal_output.push(newItem);
    },
    
  },

  actions: {
    async login({ dispatch }, auth) {
      // sign user in
      await fb.auth
        .signInWithEmailAndPassword(auth.email, auth.password)
        .then((userCredential) => {
          console.log(`User ${userCredential.user.uid} logged in`);
          // fetch user profile and set in state
          dispatch("fetchUserProfile", userCredential.user.uid);
        })
        .catch((error) => {
          console.log("User login failed..");
          this.commit("setMessage",i18n.t('firebase.'+error.code));
          this.commit("toggleModal");
        });
    },

    async signup({ dispatch }, auth) {
      // sign user up
      await fb.auth
        .createUserWithEmailAndPassword(auth.email, auth.password)
        .then((userCredential) => {
          console.log("user created " + userCredential.user.uid);
          // create user object in userCollections
          let user = {
            id: userCredential.user.uid,
            name: auth.name,
            organization: auth.organization,
            email: auth.email,
            // gets browser language up and splits de-DE to de, en-US -> en
            locale: navigator.languages[0].substring(0, navigator.languages[0].indexOf("-")),
          };
          fb.usersCollection.doc(userCredential.user.uid).set(user);
          // fetch user profile and set in state
          dispatch("fetchUserProfile", userCredential.user.uid);
          this.commit("setAuthenticated", true);
          this.commit("setMessage",i18n.t('firebase.successfulRegistration'));
          this.commit("toggleModal");
        })
        .catch((error) => {
          console.log("User creation failed.." + error);
          this.commit("setMessage",i18n.t('firebase.'+error.code));
          this.commit("toggleModal");
          this.commit("setAuthenticated", false);
          router.push("/user/login");
        });
    },

    async fetchUserProfile({ commit }, uid) {
      // fetch user profile
      await fb.usersCollection
        .doc(uid)
        .get()
        .then((doc) => {
          if (doc.exists) {
            console.log("Fetch user profile " + uid);
            // set user profile in state
            commit("setUserProfile", Object.assign({ id: uid }, doc.data()));
            this.dispatch('setLocale', doc.data().locale);
          }
        })
        .catch((error) => {
          console.log("User fetch failed.." + error);
          // and change route to the Home
          router.push("/");
        });
    },

    async updateUserName(auth) {
      // update the current user's name
      console.log("" ,auth)
      console.log("" ,auth.name)
      if (auth && auth.name) {
        await fb.usersCollection.doc(fb.auth.currentUser.uid).update({ name: auth.name});
      }
    },

    async updateUserOrganization(auth) {
      // update the current user's organization
      console.log("" ,auth)
      console.log("" ,auth.organization)
      if (auth && auth.organization) {
        await fb.usersCollection.doc(fb.auth.currentUser.uid).update({ organization: auth.organization});
      }
    },

    async reset({ dispatch }, auth) {
      // reset user pw
      if (dispatch || auth) {
        await fb.auth
          .sendPasswordResetEmail(auth.email)
          .then(() => {
            console.log("User password reset was successful.");
            this.commit("setMessage",i18n.t('firebase.successfulPasswordReset'));
            this.commit("toggleModal");
            // tbd Bitte überprüfen sie ihr postfach
            router.push("/user/login");
          })
          .catch((error) => {
            console.log("User password reset failed..", error);
            this.commit("setMessage",i18n.t('firebase.'+error.code));
            this.commit("toggleModal");
            // and change route to the Home
            router.push("/");
          });
      }
    },

    async deleteUser() {
      
      var user = await fb.auth.currentUser;

      await user
      .delete()
      .then(() => {
          fb.usersCollection.doc(this.state.user.id).delete();
          this.commit("setAuthenticated", false);
          this.commit("setMessage",i18n.t('firebase.successfulUserDelete'));
          this.commit("toggleModal");
      }).catch(function(error) {
        console.log("User delete failed.." + error);
        this.commit("setMessage",i18n.t('firebase.'+error.code));
        this.commit("toggleModal");
      });

    },

    async logout() {
      // log user out
      await fb.auth
        .signOut()
        .then(() => {
          // clear user data from state
          console.log("User is logged out..");
          this.commit("setUserProfile", null);
          this.commit("setAuthenticated", false)
        })
        .catch((error) => {
          console.log("User logging out failed.." + error);
          this.commit("setMessage",i18n.t('firebase.'+error.code));
          this.commit("toggleModal");
        });
    },

    async initData() {
      this.dispatch("fetchNutrientValues");
      this.dispatch("fetchRegions");
      this.dispatch("fetchCategories");
      this.dispatch("fetchUnits");
    },

    async fetchNutrientValues({ commit, state }) {
      if (state.nutrient_values.length != 0) {
        return;
      }
      console.log("Fetching nutrient values from DB");
      let nutrients = [];
      await fb.nutrientValuesCollection.orderBy("name_"+i18n.locale).onSnapshot((snapshot) => {
        snapshot.forEach((doc) => {
          let nutrient = doc.data();
          nutrient.id = doc.id;
          nutrient.multiple_use = doc.data().multiple_use == 'ja'; // convert to boolean
          nutrients.push(nutrient);
        });
        console.log("Loaded " + nutrients.length + " nutrient values");
        commit("setNutrientValues", nutrients);
        this.dispatch("addOutputsForProject");
      });
    },

    async fetchCategories({ commit }) {
      let categories = [];
      await fb.categoriesCollection.orderBy("name_"+i18n.locale).onSnapshot((snapshot) => {
        snapshot.forEach((doc) => {
          let category = doc.data();
          category.id = doc.id;
          categories.push(category);
        });
      });
      commit("setCategories", categories);
    },

    async fetchUnits({ commit }) {
      let units = [];
      await fb.unitsCollection.orderBy("name_"+i18n.locale).onSnapshot((snapshot) => {
        snapshot.forEach((doc) => {
          let unit = doc.data();
          unit.id = doc.id;
          units.push(unit);
        });
      });
      commit("setUnits", units);
    },

    async fetchRegions({ commit }) {
      let regions = [];
      await fb.regionsCollection.orderBy("name_"+i18n.locale).onSnapshot((snapshot) => {
        snapshot.forEach((doc) => {
          let region = doc.data();
          region.id = doc.id;
          regions.push(region);
        });
      });
      commit("setRegions", regions);
    },

    async fetchProject({ commit }, projectId) {
      console.log("Fetching project " + projectId + " from DB");
      let docRef = fb.projectsCollection.doc(projectId);
      await docRef
        .get()
        .then((doc) => {
          if (doc.exists) {
            commit("setProject", doc.data());
            this.dispatch("addOutputsForProject");
            this.dispatch("fetchDemandFulfillments")
          } else {
            console.log("No such project!");
          }
        })
        .catch((error) => {
          console.log("Error getting project:", error);
        });
    },

    async fetchProjects({ commit }) {
      if (!fb.auth.currentUser) {
        return;
      }
      console.log("Fetching projects from DB");
      await fb.projectsCollection
        .where("user_id", "==", fb.auth.currentUser.uid)
        .onSnapshot((snapshot) => {
          let loaded = [];
          snapshot.forEach((doc) => {
            let project = doc.data();
            project.id = doc.id;
            loaded.push(project);
          });
          console.log("Loaded " + loaded.length + " projects");
          commit("setProjects", loaded);
        });
    },

    async saveProject(context) {
      if (!context.state.project) {
        return;
      }
      let projectToSave = Object.assign({}, context.state.project);
      let filteredPlantOutputs = projectToSave.plant_output.filter(
        (out) =>
          !out.id ||
          (out.acreage_input && out.acreage_input != 0) ||
          out.yield_actual != out.yield
      );
      let filteredAnimalOutputs = projectToSave.animal_output.filter(
        (out) => !out.id || (out.amount_input && out.amount_input != 0)
      );

      let filteredDemandFulfillments = [];
      if(context.state.project.demand_fulfillments.length > 0) {
        for (var key in context.state.project.demand_fulfillments) {
          let demandFulfillment = context.state.project.demand_fulfillments[key];
          let filteredNutrientSources = demandFulfillment.nutrient_sources.filter(
            (out) => !out.id || (out.amount_input !== null && out.amount_input === out.amount)
          );
          console.log("Nutrient sources to save " + filteredNutrientSources.length);
          let demandFulfillmentToSave = Object.assign({}, demandFulfillment);
          demandFulfillmentToSave.nutrient_sources = filteredNutrientSources;
          filteredDemandFulfillments.push(demandFulfillmentToSave)
        }
      }
      projectToSave.plant_output = filteredPlantOutputs;
      projectToSave.animal_output = filteredAnimalOutputs;
      projectToSave.demand_fulfillments = filteredDemandFulfillments;

      /* Selbst angelegte zeilen in plant_output sollen auf jeden Fall gespeichert werden (diese besitzen keinen id wert). Bereits editierte
       Zeilen sollen gespeichert werden, z.B. yield_actual weicht vom yield (standard) ab, acreage_input existiert oder
        included === false obwohl multiple_use === "ja" (in diesem Fall wird der Wert nicht bei der Berechnung der totalen Fläche
          berücksichtigt).
       Wenn nichts editiert wurde -> plant_output is empty*/
      //delete projectToSave.nutrient_sources
      /* TBD delete projectToSave.nutrient_sources*/
      delete projectToSave.nutrient_sources;
      delete projectToSave.demand_fulfillment;

      let docRef = await fb.projectsCollection.doc(context.state.project.project_id);

      await docRef.set(projectToSave).then(() => {
          console.log("Project "+ docRef.id+" saved.");
      })
      .catch((error) => {
          console.error("Error writing project: ", error);
        });
    },

    fetchDemandFulfillments(context) {
      let proj = context.state.project;
      if (!proj) {
        return;
      } 
      let fertilizer = context.getters.nutrientValuesFertilizer;

      for (var source_idx in fertilizer) {
        let source = fertilizer[source_idx];
        
        delete source.bnf;
        delete source.main_product_de;
        delete source.main_product_en;
        delete source.multiple_use;
        delete source.yield;
        source.amount = 0;
        source.amount_input = null;
      }

      proj.nutrient_sources = fertilizer;

      
      for (var item in proj.demand_fulfillments) {
        let inputs = proj.demand_fulfillments[item].nutrient_sources;
        
        let missingNutrientInputs = fertilizer.filter(n => inputs.findIndex(out => out.id == n.id) < 0);

        missingNutrientInputs.forEach((n) => {
          inputs.push(Object.assign({
            N_t: 0,
            N_kg_ha: 0,
            P_t: 0,
            P_kg_ha: 0,
            K_t: 0,
            K_kg_ha: 0,
         }, n));
        });
      }
    },

    addOutputsForProject(context) {
      let proj = context.state.project;
      if (!proj) {
        return;
      } 
      let nutrients = context.getters.nutrientValuesPlant
      let animals = context.getters.nutrientValuesAnimal
      

      let missingPlantOutputs = nutrients.filter(n => proj.plant_output.findIndex(out => out.id == n.id) < 0);
      let missingAnimalOutputs = animals.filter(n => proj.animal_output.findIndex(out => out.id == n.id) < 0);

      // set transient value acreage_input_pct for each plant output
      for(var key in proj.plant_output) {
        var plant = proj.plant_output[key];
        if (plant.acreage_input) {
          let pct = (proj.acreage) ? plant.acreage_input / proj.acreage * 100 : 0;
          proj.plant_output[key] = Object.assign({ acreage_input_pct: pct}, plant);
        }
      }

      for(var idx in missingPlantOutputs) {
        missingPlantOutputs[idx] = Object.assign({ included: true}, missingPlantOutputs[idx]);
      }

      missingPlantOutputs.forEach(n => {
        proj.plant_output.push(Object.assign({ acreage: 0, yield_actual: n.yield}, n))
        }
      );

      missingAnimalOutputs.forEach((n) => {
        proj.animal_output.push(Object.assign({ amount_input: null }, n));
      });

      if (missingPlantOutputs.length > 0) {
        console.log("Added " + missingPlantOutputs.length + " plant outputs");
      }
      
      if (missingAnimalOutputs.length > 0) {
        console.log("Added " + missingAnimalOutputs.length + " animal outputs");
      }
    },

    removeProject(context, val) {
      context.state.projects.forEach((element) => {
        element;
      });
      fb.projectsCollection
        .doc(val.project_id)
        .delete()
        .then(() => {
          console.log("Document successfully deleted!");
          this.dispatch("fetchProjects");
        })
        .catch((error) => {
          console.error("Error removing document: ", error);
        });
    },

    setProjectName(context, val) {
      context.state.projects.forEach((element) => {
        element;
      });

      fb.projectsCollection.doc(val.id).update({ name: val.name });
    },

    removePlantOutput(context, val) {
      let outputs = context.state.project.plant_output;
      let index = outputs.indexOf(val);
      if (index >= 0) {
        outputs.splice(index, 1);
      }
    },

    removeAnimalOutput(context, val) {
      let outputs = context.state.project.animal_output;
      let index = outputs.indexOf(val);
      if (index >= 0) {
        outputs.splice(index, 1);
      }
    },

    removeNutrientSource(context, val) {
      let sources = context.state.project.demand_fulfillment.nutrient_sources;
      let index = sources.indexOf(val);
      if (index >= 0) {
        sources.splice(index, 1);
      }
    },

    removeDemandFulfillment(context, val) {
      let demand = context.state.project.demand_fulfillments;
      context.state.project.demand_fulfillment = null;
      let index = demand.indexOf(val);
      if (index >= 0) {
        demand.splice(index, 1);
      }
    },

    duplicateProject(context, val) {
      let proj = Object.assign({}, val);
      let projectNames = [];

      if (!context.state.projects) {
        context.dispatch("fetchProjects");
        context.state.projects.forEach((p) => {
          projectNames.push(p.name);
        });
      } else {
        context.state.projects.forEach((p) => {
          projectNames.push(p.name);
        });
      }

      proj.name = nameCheck(val.name, projectNames);
      proj.project_id = uuidv4();
      proj.created_on = Date.now();

      fb.projectsCollection
        .doc(proj.project_id)
        .set(proj)
        .then(() => {
          console.log("Project " + val.project_id + " successfully duplicated");
          this.dispatch("fetchProjects");
        })
        .catch((error) => {
          console.error("Error writing document: ", error);
        });
    },

    addOutputs({ commit }, selected) {
      selected.forEach((id) => {
        commit("addOutput", {
          nutrient_id: id,
          amount: 0,
        });
      });
    },

    setLocale(context, val) {
      if (!val) {
        return;
      }
      this.commit('setLocale', val)
      i18n.locale = val;
      if (context.state.user) {
        fb.usersCollection.doc(context.state.user.id).update({locale: val});
      }
    },


  },
  modules: {},

  getters: {
    showModal: state => {
      return state.showModal;
    },

    message: (state) => {
      return state.message;
    },

    lang: (state) => {
      return state.lang;
    },

    regionsForSelectedCountry: (state) => {
      return state.regions.filter((r) => r.countryCode == state.country);
    },

    projectRegionAreaSize: (state) => {
      if (state.project.region_id) {
        return state.regions.find((r) => r.id === state.project.region_id).size;
      } else {
        return 0;
      }
    },

    nutrientValuesPlant: (state) => {
      return state.nutrient_values.filter(
        (n) => n.category_id.includes("crop") || n.category_id.includes("input")
      );
    },

    nutrientValuesAnimal: (state) => {
      return state.nutrient_values.filter((n) =>
        n.category_id.includes("animal")
      );
    },

    nutrientValuesFertilizer: (state) => {
      let filteredFertilizer = state.nutrient_values.filter(
        (n) => n.category_id.includes("fertilizer")
      );
      return filteredFertilizer;
    },

    regionNames: (state) => {
      return state.project
        ? state.project.regions.flatMap((id) =>
            state.regions.filter((r) => r.id == id).map((r) => r['name_'+i18n.locale])
          )
        : "";
    },

    exportProject: (state) => {
      if (!state.project) {
        return;
      }
      
      let filteredPlantOutputs = state.project.plant_output.filter(
        (out) =>
          !out.id ||
          (out.acreage_input && out.acreage_input != 0) ||
          out.yield_actual != out.yield
      );

      let plantOutputs = [];

      if(filteredPlantOutputs.length > 0) {
        for (var key in filteredPlantOutputs) {
          let output = filteredPlantOutputs[key];
          let outputExport = [
            output['name_'+i18n.locale],
            output.acreage_input,
            output.acreage_input_pct,
            output.yield_actual,
            output.yield
          ];
          plantOutputs.push(outputExport);
        }
      }

      let filteredAnimalOutputs = state.project.animal_output.filter(
        (out) => !out.id || (out.amount_input && out.amount_input != 0)
      );
      
      let animalOutputs = [];
      if(filteredAnimalOutputs.length > 0) {
        for (var idx in filteredAnimalOutputs) {
          let output = filteredAnimalOutputs[idx];
          let unitName = state.units.find((c) => c.id == output.unit_id);
          let outputExport = [
            output['name_'+i18n.locale],
            output.amount_input,
            unitName['name_'+i18n.locale]
          ];
          animalOutputs.push(outputExport);
        }
      }
      
      let demandFulfillments = [];
      let demandFulfillmentsNames = [];
      let fertilizerScenarios = [];
      
      if(state.project.demand_fulfillments.length > 0) {
        for (var el in state.project.demand_fulfillments) {
          let demandFulfillment = state.project.demand_fulfillments[el];
          let filteredNutrientSources = demandFulfillment.nutrient_sources.filter(
            (out) => !out.id || (out.amount_input !== null && out.amount_input === out.amount)
          );
          
          let demandFulfillmentsOutputs = [];
          if(filteredNutrientSources.length > 0) {
            for (var el_idx in filteredNutrientSources) {
              let output = filteredNutrientSources[el_idx];
             
              let outputExport = [
                output['name_'+i18n.locale],
                output.amount_input,
                parseFloat(output.N_t).toFixed(2),
                parseFloat(output.N_kg_ha).toFixed(2),
                parseFloat(output.P_t).toFixed(2),
                parseFloat(output.P_kg_ha).toFixed(2),
                parseFloat(output.K_t).toFixed(2),
                parseFloat(output.K_kg_ha).toFixed(2),
              ];
              demandFulfillmentsOutputs.push(outputExport);
            }
            demandFulfillments.push(demandFulfillmentsOutputs);
            demandFulfillmentsNames.push(demandFulfillment.name);

            let scenarioExport = [
              [
                i18n.t('demandFulfillmentOverview.rowBalance'),
                demandFulfillment.scenario.N.surplus_pct.toFixed(1),
                demandFulfillment.scenario.N.surplus.toFixed(2),
                demandFulfillment.scenario.N.surplus_per_ha.toFixed(2),
                demandFulfillment.scenario.P.surplus_pct.toFixed(1),
                demandFulfillment.scenario.P.surplus.toFixed(2),
                demandFulfillment.scenario.P.surplus_per_ha.toFixed(2),
                demandFulfillment.scenario.K.surplus_pct.toFixed(1),
                demandFulfillment.scenario.K.surplus.toFixed(2),
                demandFulfillment.scenario.K.surplus_per_ha.toFixed(2),
              ],
              [
                i18n.t('demandFulfillmentOverview.rowFertilizer'),
                '',
                demandFulfillment.scenario.N.total_extern_fertilizer_t.toFixed(2),
                demandFulfillment.scenario.N.total_extern_fertilizer_kg_ha.toFixed(2),
                '',
                demandFulfillment.scenario.P.total_extern_fertilizer_t.toFixed(2),
                demandFulfillment.scenario.P.total_extern_fertilizer_kg_ha.toFixed(2),
                '',
                demandFulfillment.scenario.K.total_extern_fertilizer_t.toFixed(2),
                demandFulfillment.scenario.K.total_extern_fertilizer_kg_ha.toFixed(2)             
              ],
              [
                i18n.t('demandFulfillmentOverview.rowFulfillment'),
                demandFulfillment.scenario.N.extern_fertilizer_surplus_pct.toFixed(1),
                demandFulfillment.scenario.N.extern_fertilizer_surplus_t.toFixed(2),
                demandFulfillment.scenario.N.extern_fertilizer_surplus_kg_ha.toFixed(2),
                demandFulfillment.scenario.P.extern_fertilizer_surplus_pct.toFixed(1),
                demandFulfillment.scenario.P.extern_fertilizer_surplus_t.toFixed(2),
                demandFulfillment.scenario.P.extern_fertilizer_surplus_kg_ha.toFixed(2),
                demandFulfillment.scenario.K.extern_fertilizer_surplus_pct.toFixed(1),
                demandFulfillment.scenario.K.extern_fertilizer_surplus_t.toFixed(2),
                demandFulfillment.scenario.K.extern_fertilizer_surplus_kg_ha.toFixed(2),
              ]
            ];

            fertilizerScenarios.push(scenarioExport);

          }
        }
      }
      let projectExport = {
        plant_outputs: plantOutputs,
        animal_outputs: animalOutputs,
        fertilizer: demandFulfillments,
        demandFulfillmentNames: demandFulfillmentsNames,
        scenarios: fertilizerScenarios
      };
      return projectExport;
    },

    /**
     * Computes all relevant values for the balance sheet.
     *
     * Values are grouped by nutrient type N,P,K.
     */
    balance: (state) => {
      let result = {
        N: {},
        P: {},
        K: {},
      };
      if (!state.project) {
        return result;
      }

      result.deposition = state.project.deposition;
      result.losses_storage = state.project.lossesStorage;
      result.losses_output = state.project.lossesOutput;

      // Anbaufläche
      result.acreage_sum = state.project.plant_output
        .filter((output) => output.acreage_input && output.included)
        .reduce((val, output) => val + parseInt(output.acreage_input), 0);

      for (let i in Object.keys(NUTRIENT_KEYS)) {
        let n = NUTRIENT_KEYS[i];
        // Nährstoffbedarf in kg
        result[n].nutrient_demand = state.project.plant_output
          .filter((output) => output.acreage_input)
          .reduce(
            (val, output) => val + parseInt(output.acreage_input) * output[n],
            0
          );

        // Hofdüngeranfall in kg
        result[n].fertilizer_prod = state.project.animal_output
          .filter((output) => output.amount_input && output.category_id !== CATEGORY_ID_DIRECT_INPUT)
          .reduce(
            (val, output) => val + parseInt(output.amount_input) * output[n],
            0
          );
        
        for (let j in state.project.animal_output) {
          let animalOutput = state.project.animal_output[j];
          if (animalOutput.category_id === CATEGORY_ID_DIRECT_INPUT) {
            result[n].fertilizer_prod += animalOutput[n];
          }
        }


        if (n == "N") {
          // the following values are only valid for N
          result[n].bnf = state.project.plant_output
            .filter((output) => output.acreage_input && output.bnf)
            .reduce(
              (val, output) =>
                val + parseInt(output.acreage_input) * output.bnf,
              0
            );

          result[n].deposition =
            (state.project.deposition * result.acreage_sum) / 1000;

          result[n].losses_storage =
            (state.project.lossesStorage * result[n].fertilizer_prod) / 100;
          result[n].losses_output =
            ((result[n].fertilizer_prod - result[n].losses_storage) * state.project.lossesOutput) /100;
          result[n].losses = result[n].losses_storage + result[n].losses_output;
        } else {
          result[n].bnf = 0;
          result[n].deposition = 0;
          result[n].losses_storage = 0;
          result[n].losses_output = 0;
          result[n].losses = 0;
        }

        if (result.acreage_sum) {
          // Nährstoffbedarf in kg/ha
          result[n].nutrient_demand_per_ha =
            result[n].nutrient_demand / result.acreage_sum;
          // Hofdüngeranfall in kg
          result[n].fertilizer_prod_per_ha =
            result[n].fertilizer_prod / result.acreage_sum;
          result[n].bnf_per_ha = result[n].bnf / result.acreage_sum;
          result[n].deposition_per_ha =
            result[n].deposition / result.acreage_sum;
         
          
          result[n].losses_storage_per_ha = result[n].losses_storage / result.acreage_sum;

          result[n].losses_output_per_ha = ((result[n].fertilizer_prod_per_ha - result[n].losses_storage_per_ha) * state.project.lossesOutput) /100;

          result[n].losses_per_ha = result[n].losses_storage_per_ha + result[n].losses_output_per_ha;
          result[n].losses_pct = result[n].losses_per_ha/result[n].fertilizer_prod_per_ha * 100;
          
          if (n == "N") {
            state.project.losses_pct = result[n].losses_pct;
          }

          result[n].losses = (result[n].fertilizer_prod*result[n].losses_pct)/100;
        } else {
          result[n].nutrient_demand_per_ha = 0;
          result[n].fertilizer_prod_per_ha = 0;
          result[n].bnf_per_ha = 0;
          result[n].deposition_per_ha = 0;
          result[n].losses_storage_per_ha = 0;
          result[n].losses_output_per_ha = 0;
          result[n].losses_per_ha = 0;
          result[n].losses_pct = 0;
          result[n].losses = 0;
        }
        if (result[n].fertilizer_prod) {
          result[n].losses = (result[n].fertilizer_prod*result[n].losses_pct)/100;
        } 

        // Bedarfsdeckung
        
        result[n].demand_fulfillment =
          result[n].fertilizer_prod +
          result[n].bnf +
          result[n].deposition*1000 -
          result[n].losses;

          result[n].demand_fulfillment_overview = result[n].fertilizer_prod 
          
        if (result[n].nutrient_demand) {
          result[n].demand_fulfillment_pct = result[n].demand_fulfillment / result[n].nutrient_demand * 100;
          result[n].surplus_pct = result[n].demand_fulfillment_overview / result[n].nutrient_demand * 100;
        } else {
          result[n].demand_fulfillment_pct = 0;
          result[n].surplus_pct = 0;
        }

        
        result[n].demand_fulfillment_per_ha =
          result[n].fertilizer_prod_per_ha +
          result[n].bnf_per_ha +
          result[n].deposition_per_ha*1000 -
          result[n].losses_per_ha;


        result[n].demand_fulfillment_per_ha_overview = result[n].fertilizer_prod_per_ha;
        // Überschuss
        if(n === "N") {
          if (result[n].nutrient_demand && (result[n].fertilizer_prod > 0) && (result.acreage_sum > 0)) {
            result[n].surplus =
            result[n].demand_fulfillment_overview - result[n].nutrient_demand 
            + result[n].bnf + result[n].deposition * 1000 - result[n].losses;

            result[n].surplus_standard =
            result[n].demand_fulfillment_overview - result[n].nutrient_demand;

            result[n].surplus_standard_per_ha =
            result[n].surplus_standard / result.acreage_sum;
  
          result[n].surplus_per_ha =
            result[n].surplus / result.acreage_sum;
  
          result[n].surplus_pct = result[n].surplus / result[n].nutrient_demand * 100;
          } else {
            result[n].surplus =
            result[n].demand_fulfillment_overview - result[n].nutrient_demand;
          result[n].surplus_per_ha =
            result[n].demand_fulfillment_per_ha_overview -
            result[n].nutrient_demand_per_ha;
            result[n].surplus_standard =
            result[n].demand_fulfillment_overview - result[n].nutrient_demand;

            result[n].surplus_standard_per_ha =
            result[n].demand_fulfillment_per_ha_overview -
            result[n].nutrient_demand_per_ha;
          }
          result[n].surplus_pct_standard = result[n].demand_fulfillment_overview / result[n].nutrient_demand * 100;

        } else {
          result[n].surplus =
            result[n].demand_fulfillment_overview - result[n].nutrient_demand;
          result[n].surplus_per_ha =
            result[n].demand_fulfillment_per_ha_overview -
            result[n].nutrient_demand_per_ha;
        }

      }

      result.items = [];
      // filter only used items
      let filteredPlantOutputs = state.project.plant_output.filter(
        (out) =>
          !out.id ||
          (out.acreage_input && out.acreage_input != 0) ||
          out.yield_actual != out.yield
      );
      let filteredAnimalOutputs = state.project.animal_output.filter(
        (out) => !out.id || (out.amount_input && out.amount_input != 0)
      );


      let balanceOutput = [[], [], []]
      /* Animal Table */
      filteredAnimalOutputs.forEach( animal => {
        // Group already existing
        if(balanceOutput[1].filter(group => group.name === animal.category_id).length > 0 ){
          let groupIndex = balanceOutput[1].findIndex(group => group.name === animal.category_id)

          // direct input of N,P,K -> just adding values
          if (animal.category_id ===  CATEGORY_ID_DIRECT_INPUT) {
            balanceOutput[1][groupIndex].Nkg += parseFloat(animal.N)
            balanceOutput[1][groupIndex].Pkg += parseFloat(animal.P)
            balanceOutput[1][groupIndex].Kkg += parseFloat(animal.K)
          } else {
            balanceOutput[1][groupIndex].Nkg += parseFloat(animal.N)*parseFloat(animal.amount_input)
            balanceOutput[1][groupIndex].Pkg += parseFloat(animal.P)*parseFloat(animal.amount_input)
            balanceOutput[1][groupIndex].Kkg += parseFloat(animal.K)*parseFloat(animal.amount_input)}     
        } else {
          // Add as new group

          // direct input of N,P,K -> amount has to be 1
          if (animal.category_id ===  CATEGORY_ID_DIRECT_INPUT) {
            balanceOutput[1].push({
              "name": animal.category_id,
              "Nkg": parseFloat(animal.N),
              "Pkg": parseFloat(animal.P),
              "Kkg": parseFloat(animal.K)
            })
          } else {
            // normal animal
            balanceOutput[1].push({
              "name": animal.category_id,
              "Nkg": parseFloat(animal.N)*parseFloat(animal.amount_input),
              "Pkg": parseFloat(animal.P)*parseFloat(animal.amount_input),
              "Kkg": parseFloat(animal.K)*parseFloat(animal.amount_input)
            })
          }
        }
      })

      /* Plants */
      filteredPlantOutputs.forEach(plant => {
        // Groups already existing
        if(balanceOutput[0].filter(group => group.name === plant.category_id).length > 0) {
          let groupIndex = balanceOutput[0].findIndex(group => group.name === plant.category_id) 
          balanceOutput[0][groupIndex].Nkg += parseFloat(plant.N)*parseFloat(plant.acreage_input)
          balanceOutput[0][groupIndex].Pkg += parseFloat(plant.P)*parseFloat(plant.acreage_input)
          balanceOutput[0][groupIndex].Kkg += parseFloat(plant.K)*parseFloat(plant.acreage_input)

          // has bnf
          if(plant.bnf) {
            // is bnf group existing?
            if(balanceOutput[2].filter(group => group.name === plant.category_id).length > 0) {
              let groupIndex = balanceOutput[2].findIndex(group => group.name === plant.category_id) 
              balanceOutput[2][groupIndex].Nkg += parseFloat(plant.bnf)*parseFloat(plant.acreage_input)
            } else {
              // bnf not existing -> when added non bnf from same group before
              balanceOutput[2].push({
                "name": plant.category_id,
                "Nkg": parseFloat(plant.bnf)*parseFloat(plant.acreage_input),
                "Pkg": 0,
                "Kkg": 0
              })
            }
          }
        } else {
          // add as a new group
          balanceOutput[0].push({
            "name": plant.category_id,
            "Nkg": parseFloat(plant.N)*parseFloat(plant.acreage_input),
            "Pkg": parseFloat(plant.P)*parseFloat(plant.acreage_input),
            "Kkg": parseFloat(plant.K)*parseFloat(plant.acreage_input)
          })

          if(plant.bnf) {
            balanceOutput[2].push({
              "name": plant.category_id,
              "Nkg": parseFloat(plant.bnf)*parseFloat(plant.acreage_input),
              "Pkg": 0,
              "Kkg": 0
            })
          }
        }
      })


      for(let i = 0; i < balanceOutput.length; i++ ) {
        balanceOutput[i].forEach(group => {
          group.N = result.acreage_sum > 0? (group.Nkg / result.acreage_sum) : group.Nkg;
          group.P = result.acreage_sum > 0? (group.Pkg / result.acreage_sum) : group.Pkg;
          group.K = result.acreage_sum > 0? (group.Kkg / result.acreage_sum) : group.Kkg;
         })
      }

      result.groups = balanceOutput


      return result;
    },
  },
});
